ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})


//////////////////
// WEBPACK FOOTER
// ./~/ace-builds/src-min-noconflict/snippets/json.js
// module id = 442
// module chunks = 1